// export const API_BASE = '/api';


export const API_BASE = "https://vyte3mlu0l.execute-api.ap-south-1.amazonaws.com/dev"
//  export const API_BASE = "http://127.0.0.1:8000"

/**
 * Tab title shown until org_preferences resolves and supplies the org's own name.
 * Keep in sync with <title> in public/index.html, which is the pre-JS title and
 * cannot import this.
 */
export const DEFAULT_TITLE = 'Vision For Life';

/**
 * The site-wide tab title: the org's own name, falling back to DEFAULT_TITLE
 * before the org_preferences fetch resolves. Single source of truth — OrgContext
 * applies it when the org loads, the try-on routes suffix it, and they restore it
 * on unmount.
 */
export const siteTitle = (orgName?: string | null): string => orgName || DEFAULT_TITLE;
